import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import "@/App.css";

import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import ServicePage from "@/pages/ServicePage";
import Projects from "@/pages/Projects";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import PropertyManagers from "@/pages/PropertyManagers";
import ContractorPartners from "@/pages/ContractorPartners";

let lenisInstance = null;

function SmoothScroll({ children }) {
  useEffect(() => {
    const prefersReduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (prefersReduced) return;
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true, lerp: 0.09 });
    lenisInstance = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      lenisInstance = null;
    };
  }, []);
  return children;
}

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    if (lenisInstance) lenisInstance.scrollTo(0, { immediate: true });
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  return (
    <div className="App bg-ink min-h-screen">
      <BrowserRouter>
        <SmoothScroll>
          <ScrollToTop />
          <Layout>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/hvac-service" element={<ServicePage slug="hvac-service" />} />
              <Route path="/furnace-installation" element={<ServicePage slug="furnace-installation" />} />
              <Route path="/ac-installation" element={<ServicePage slug="ac-installation" />} />
              <Route path="/light-commercial-hvac" element={<ServicePage slug="light-commercial-hvac" />} />
              <Route path="/rtu-change-outs" element={<ServicePage slug="rtu-change-outs" />} />
              <Route path="/preventive-maintenance" element={<ServicePage slug="preventive-maintenance" />} />
              <Route path="/technology-diagnostics" element={<ServicePage slug="technology-diagnostics" />} />
              <Route path="/projects" element={<Projects />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/property-managers" element={<PropertyManagers />} />
              <Route path="/contractor-partners" element={<ContractorPartners />} />
            </Routes>
          </Layout>
        </SmoothScroll>
      </BrowserRouter>
    </div>
  );
}

export default App;
